import { LOAD_CALENDARS, SHOW_CALENDAR, HIDE_CALENDAR, TOGGLE_CALENDAR } from 'constants/ActionTypes';
import axios from "axios";

const prepareCalendar = (calendar) => {
    calendar.events = [];

    // if calendar is related to aircraft, try to rewrite name by aircraft registration number
    if (calendar.aircraft) {
        calendar.name = calendar.aircraft.reg_no || calendar.name;
    }

    return calendar;
};

export function calendarsLoaded(payload) {
  return {
    type: LOAD_CALENDARS,
    payload
  }
}

export function loadCalendars() {
  return dispatch => {
    axios.get('/api/operator/calendar')
      .then((res) =>{
          let calendars = {};
          for (let i in res.data) {
              const calendarData = res.data[i];
              calendars[calendarData.id] = prepareCalendar(calendarData);
          }

          dispatch({
            type: LOAD_CALENDARS,
            payload: calendars
          });
      });
  }
}

export function hideCalendar(calendarId) {
  return {
    type: HIDE_CALENDAR,
    payload: calendarId
  }
}

export function showCalendar(calendarId) {
  return {
    type: SHOW_CALENDAR,
    payload: calendarId
  }
}

export function toggleCalendar(calendarId) {
  return {
    type: TOGGLE_CALENDAR,
    payload: calendarId
  }
}



// WEBPACK FOOTER //
// ./actions/Calendars.js